import { Dialog } from '@headlessui/react';
import { Fragment } from 'react';

const VoucherModal = ({ isOpen, onClose, title, image_url, link_memories }) => {
  return (
    <Dialog open={isOpen} onClose={onClose} as={Fragment}>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 overflow-hidden">
        <Dialog.Panel
          className="bg-white max-w-lg w-full rounded-xl p-8 shadow-2xl overflow-y-auto"
          style={{
            maxHeight: 'calc(100vh - 10rem)',
            scrollbarGutter: 'stable' // Optional: prevents layout shift
          }}
        >
          <Dialog.Title className="text-2xl font-bold mb-4">{title}</Dialog.Title>

          <div className="mb-6">
            <img src={image_url} alt="voucher image" className="w-full h-auto mb-8" />
            {link_memories && (
              <div className="flex items-center mb-4">
                <span className="mr-2 font-bold">Photo result:</span>
                <a
                  href={link_memories}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:text-blue-600 underline break-all"
                >
                  {link_memories}
                </a>
              </div>
            )}
          </div>

          <div className="flex justify-end">
            <button
              onClick={onClose}
              className="bg-blue-500 hover:bg-blue-600 text-white px-5 py-3 rounded-lg"
            >
              Close
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default VoucherModal;
